import React from 'react';
import ErrorState from '../../../commonComponents/ErrorState';
import { getApiErrorMessage } from '../utils/apiError';

interface QueryErrorStateProps {
  title: string;
  onRetry: () => void;
  /** The rejected query's error, if its message is worth surfacing. */
  error?: unknown;
}

/**
 * The retry panel a list shows when its query failed and there is nothing cached to
 * keep on screen. Prefers the API's own message over a generic line, since a 400
 * here usually says exactly what was wrong.
 */
const QueryErrorState: React.FC<QueryErrorStateProps> = ({ title, onRetry, error }) => (
  <ErrorState
    title={title}
    message={getApiErrorMessage(error, 'Please try again.')}
    onRetry={onRetry}
  />
);

export default QueryErrorState;
